/** Teksty czatu wewnętrznego (klucze: chat.*). */
export const chatPl = {
  nav: 'Czat',
  title: 'Czat zespołu',
  subtitle: 'Rozmowy 1:1, grupy, ogłoszenia i wątki o klientach, leadach i wnioskach',
  you: 'Ty',
  deleted: 'Wiadomość usunięta',
  attachmentLabel: 'Załącznik',
  muted: 'Wyciszona',
  pinned: 'Przypięta',
  live: {
    on: 'Na żywo',
    off: 'Bez połączenia na żywo',
    onHint: 'Nowe wiadomości pojawiają się natychmiast.',
    offHint: 'Łączę ponownie — do tego czasu liczniki odświeżają się co minutę.',
  },
  kind: {
    DIRECT: 'Rozmowa 1:1',
    GROUP: 'Grupa',
    BROADCAST: 'Ogłoszenie',
    SUBJECT: 'Wątek o obiekcie',
  },
  time: {
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
  },
  plural: {
    unreadMessages: {
      one: 'nieprzeczytaną wiadomość',
      few: 'nieprzeczytane wiadomości',
      many: 'nieprzeczytanych wiadomości',
    },
    inConversations: {
      one: 'rozmowie',
      few: 'rozmowach',
      many: 'rozmowach',
    },
  },
  hero: {
    newConversation: 'Nowa rozmowa',
    unread: 'Nieprzeczytane',
    unreadHint: 'w rozmowach: {count}',
    conversations: 'Rozmowy',
    conversationsHint: 'aktywne, bez archiwum',
    today: 'Aktywne dziś',
    todayHint: 'wiadomość w ostatnich 24 h',
    pinned: 'Przypięte',
    pinnedHint: 'zawsze na górze listy',
    insightUnread: 'Masz {messages} w {conversations}.',
    insightEmpty: 'Nie masz jeszcze żadnych rozmów — napisz do kolegi albo załóż wątek o kliencie.',
    insightCaughtUp: 'Wszystko przeczytane. Nowe wiadomości pojawią się tu same.',
    jumpToFirst: 'Przejdź do pierwszej',
  },
  list: {
    label: 'Lista rozmów',
    search: 'Szukaj rozmowy lub osoby…',
    clearSearch: 'Wyczyść wyszukiwanie',
    tabAll: 'Wszystkie',
    tabUnread: 'Nieprzeczytane',
    tabArchived: 'Archiwum',
    noMessages: 'Brak wiadomości',
    noResults: 'Nic nie znaleziono',
    error: 'Nie udało się wczytać rozmów.',
    unreadCount: 'Nieprzeczytane wiadomości: {count}',
    empty: {
      all: 'Brak rozmów',
      unread: 'Brak nieprzeczytanych wiadomości',
      archived: 'Archiwum jest puste',
    },
    emptyHint: 'Zacznij rozmowę z kolegą z zespołu albo załóż grupę.',
  },
  thread: {
    pick: 'Wybierz rozmowę',
    pickHint: 'Wybierz rozmowę z listy albo zacznij nową.',
    unavailable: 'Ta rozmowa jest niedostępna',
    unavailableHint: 'Mogła zostać usunięta albo nie masz do niej dostępu.',
    backToList: 'Wróć do listy rozmów',
    messages: 'Wiadomości',
    empty: 'Brak wiadomości',
    emptyHint: 'Napisz pierwszą wiadomość poniżej.',
    error: 'Nie udało się wczytać wiadomości.',
    loadOlder: 'Wczytaj starsze wiadomości',
    start: 'Początek rozmowy',
    newMessages: 'Nowe wiadomości',
    newBelow: 'Nowe wiadomości: {count} — przewiń na dół',
    toBottom: 'Przewiń na dół',
    participantsCount: 'Uczestnicy: {count}',
    andMore: 'i {count} więcej',
  },
  composer: {
    placeholder: 'Napisz wiadomość…',
    send: 'Wyślij',
    sendHint: 'Wyślij (Enter) · nowa linia: Shift+Enter',
    attach: 'Dodaj załącznik',
    attachments: 'Załączniki do wysłania',
    drop: 'Upuść pliki, aby je dołączyć',
    replyTo: 'Odpowiedź dla: {name}',
    cancelReply: 'Anuluj odpowiedź',
    broadcastReadOnly: 'To ogłoszenie — odpowiadać mogą tylko jego autorzy. Możesz zareagować emoji.',
    archived: 'Rozmowa jest w archiwum. Przywróć ją, aby pisać.',
    cannotPost: 'Nie możesz pisać w tej rozmowie.',
    restore: 'Przywróć z archiwum',
  },
  message: {
    reply: 'Odpowiedz',
    more: 'Więcej',
    copy: 'Kopiuj tekst',
    copied: 'Skopiowano do schowka',
    edit: 'Edytuj',
    editHint: 'Enter — zapisz, Esc — anuluj',
    edited: 'edytowano',
    delete: 'Usuń',
    sending: 'Wysyłanie…',
    sent: 'Wysłano',
    seen: 'Przeczytano',
    failed: 'Nie wysłano.',
    retry: 'Ponów',
    discard: 'Usuń',
  },
  delete: {
    title: 'Usunąć wiadomość?',
    description: 'Wiadomość zniknie dla wszystkich uczestników — zostanie tylko informacja, że ją usunięto.',
  },
  reaction: {
    add: 'Dodaj reakcję',
    toggle: 'Reakcja {emoji}: {count}',
  },
  attachment: {
    download: 'Pobierz',
    preview: 'Podgląd: {name}',
  },
  upload: {
    tooMany: 'W jednej wiadomości można wysłać maksymalnie {max} załączników.',
    badType: 'Niedozwolony typ pliku: {name}.',
    tooBig: 'Plik „{name}” jest za duży (maks. {max}).',
    failed: 'Nie udało się wgrać pliku „{name}”.',
    errorShort: 'Błąd wgrywania',
    remove: 'Usuń załącznik {name}',
  },
  typing: {
    one: '{name} pisze…',
    two: '{a} i {b} piszą…',
    many: 'Kilka osób pisze…',
    short: 'pisze…',
  },
  menu: {
    open: 'Opcje rozmowy',
    info: 'Informacje o rozmowie',
    pin: 'Przypnij',
    unpin: 'Odepnij',
    mute: 'Wycisz',
    mute1h: 'Na 1 godzinę',
    mute8h: 'Na 8 godzin',
    muteTomorrow: 'Do jutra rano (8:00)',
    unmute: 'Włącz powiadomienia',
    archive: 'Archiwizuj',
    unarchive: 'Przywróć z archiwum',
    leave: 'Opuść rozmowę',
    left: 'Opuszczono rozmowę',
  },
  leave: {
    title: 'Opuścić rozmowę?',
    description: 'Opuścisz rozmowę „{title}” i przestaniesz dostawać jej wiadomości. Wrócić możesz tylko, gdy ktoś Cię ponownie doda.',
  },
  info: {
    title: 'Informacje o rozmowie',
    rename: 'Zmień nazwę',
    created: 'Utworzono {date}',
    participants: 'Uczestnicy ({count})',
    owner: 'Właściciel',
    add: 'Dodaj osoby',
    addSelected: 'Dodaj ({count})',
    added: 'Dodano uczestników',
    remove: 'Usuń {name} z rozmowy',
  },
  new: {
    open: 'Nowa rozmowa',
    title: 'Nowa rozmowa',
    description: 'Wybierz osobę, utwórz grupę albo wyślij ogłoszenie do zespołu.',
    tabDirect: 'Osoba',
    tabGroup: 'Grupa',
    tabBroadcast: 'Ogłoszenie',
    searchPeople: 'Szukaj osoby…',
    people: 'Osoby',
    selected: 'Wybrane osoby',
    removePerson: 'Usuń {name}',
    noPeople: 'Nie znaleziono osób',
    error: 'Nie udało się wczytać osób.',
    groupTitle: 'Nazwa grupy (opcjonalnie)',
    groupTitlePlaceholder: 'np. Handlowcy region południe',
    broadcastTitle: 'Temat ogłoszenia',
    broadcastTitlePlaceholder: 'np. Nowy cennik od 1 listopada',
    firstMessage: 'Pierwsza wiadomość (opcjonalnie)',
    firstMessagePlaceholder: 'Napisz od razu, o co chodzi…',
    broadcastHint: 'Ogłoszenie czytają wszyscy odbiorcy, ale piszą w nim tylko autorzy. Odbiorcy mogą reagować emoji.',
    selectSalesReps: 'Zaznacz wszystkich handlowców ({count})',
    unselectSalesReps: 'Odznacz wszystkich handlowców',
    createGroup: 'Utwórz grupę',
    sendBroadcast: 'Wyślij ogłoszenie',
  },
  subject: {
    open: {
      CUSTOMER: 'Rozmowa o kliencie',
      LEAD: 'Rozmowa o leadzie',
      APPROVAL_REQUEST: 'Rozmowa o wniosku',
    },
    type: {
      CUSTOMER: 'Klient',
      LEAD: 'Lead',
      APPROVAL_REQUEST: 'Wniosek',
    },
    goTo: 'Przejdź do: {label}',
    notFound: 'Nie możesz rozmawiać o tym obiekcie — jest poza Twoim zakresem danych.',
  },
  toast: {
    open: 'Otwórz',
  },
};

export const chatEn: typeof chatPl = {
  nav: 'Chat',
  title: 'Team chat',
  subtitle: 'One-to-one chats, groups, announcements and threads about customers, leads and requests',
  you: 'You',
  deleted: 'Message deleted',
  attachmentLabel: 'Attachment',
  muted: 'Muted',
  pinned: 'Pinned',
  live: {
    on: 'Live',
    off: 'Live connection lost',
    onHint: 'New messages appear instantly.',
    offHint: 'Reconnecting — counters refresh every minute until then.',
  },
  kind: {
    DIRECT: 'Direct chat',
    GROUP: 'Group',
    BROADCAST: 'Announcement',
    SUBJECT: 'Record thread',
  },
  time: {
    today: 'Today',
    yesterday: 'Yesterday',
  },
  plural: {
    unreadMessages: {
      one: 'unread message',
      few: 'unread messages',
      many: 'unread messages',
    },
    inConversations: {
      one: 'conversation',
      few: 'conversations',
      many: 'conversations',
    },
  },
  hero: {
    newConversation: 'New conversation',
    unread: 'Unread',
    unreadHint: 'across conversations: {count}',
    conversations: 'Conversations',
    conversationsHint: 'active, archive excluded',
    today: 'Active today',
    todayHint: 'message in the last 24 h',
    pinned: 'Pinned',
    pinnedHint: 'always at the top of the list',
    insightUnread: 'You have {messages} in {conversations}.',
    insightEmpty: 'You have no conversations yet — message a teammate or open a thread about a customer.',
    insightCaughtUp: 'All caught up. New messages will show up here on their own.',
    jumpToFirst: 'Jump to the first one',
  },
  list: {
    label: 'Conversation list',
    search: 'Search conversations or people…',
    clearSearch: 'Clear search',
    tabAll: 'All',
    tabUnread: 'Unread',
    tabArchived: 'Archive',
    noMessages: 'No messages',
    noResults: 'Nothing found',
    error: 'Could not load conversations.',
    unreadCount: 'Unread messages: {count}',
    empty: {
      all: 'No conversations',
      unread: 'No unread messages',
      archived: 'The archive is empty',
    },
    emptyHint: 'Start a chat with a teammate or create a group.',
  },
  thread: {
    pick: 'Select a conversation',
    pickHint: 'Pick a conversation from the list or start a new one.',
    unavailable: 'This conversation is unavailable',
    unavailableHint: 'It may have been removed or you may not have access to it.',
    backToList: 'Back to conversations',
    messages: 'Messages',
    empty: 'No messages yet',
    emptyHint: 'Write the first message below.',
    error: 'Could not load messages.',
    loadOlder: 'Load older messages',
    start: 'Start of the conversation',
    newMessages: 'New messages',
    newBelow: 'New messages: {count} — scroll to the bottom',
    toBottom: 'Scroll to the bottom',
    participantsCount: 'Participants: {count}',
    andMore: 'and {count} more',
  },
  composer: {
    placeholder: 'Write a message…',
    send: 'Send',
    sendHint: 'Send (Enter) · new line: Shift+Enter',
    attach: 'Add attachment',
    attachments: 'Attachments to send',
    drop: 'Drop files to attach them',
    replyTo: 'Replying to {name}',
    cancelReply: 'Cancel reply',
    broadcastReadOnly: 'This is an announcement — only its authors can post. You can react with emoji.',
    archived: 'This conversation is archived. Restore it to write.',
    cannotPost: 'You cannot post in this conversation.',
    restore: 'Restore from archive',
  },
  message: {
    reply: 'Reply',
    more: 'More',
    copy: 'Copy text',
    copied: 'Copied to clipboard',
    edit: 'Edit',
    editHint: 'Enter to save, Esc to cancel',
    edited: 'edited',
    delete: 'Delete',
    sending: 'Sending…',
    sent: 'Sent',
    seen: 'Seen',
    failed: 'Not sent.',
    retry: 'Retry',
    discard: 'Delete',
  },
  delete: {
    title: 'Delete this message?',
    description: 'The message disappears for everyone — only a note that it was deleted remains.',
  },
  reaction: {
    add: 'Add reaction',
    toggle: 'Reaction {emoji}: {count}',
  },
  attachment: {
    download: 'Download',
    preview: 'Preview: {name}',
  },
  upload: {
    tooMany: 'You can attach up to {max} files to one message.',
    badType: 'File type not allowed: {name}.',
    tooBig: 'File "{name}" is too large (max {max}).',
    failed: 'Could not upload "{name}".',
    errorShort: 'Upload failed',
    remove: 'Remove attachment {name}',
  },
  typing: {
    one: '{name} is typing…',
    two: '{a} and {b} are typing…',
    many: 'Several people are typing…',
    short: 'typing…',
  },
  menu: {
    open: 'Conversation options',
    info: 'Conversation info',
    pin: 'Pin',
    unpin: 'Unpin',
    mute: 'Mute',
    mute1h: 'For 1 hour',
    mute8h: 'For 8 hours',
    muteTomorrow: 'Until tomorrow morning (8:00)',
    unmute: 'Turn notifications on',
    archive: 'Archive',
    unarchive: 'Restore from archive',
    leave: 'Leave conversation',
    left: 'You left the conversation',
  },
  leave: {
    title: 'Leave this conversation?',
    description: 'You will leave "{title}" and stop receiving its messages. You can only return if someone adds you again.',
  },
  info: {
    title: 'Conversation info',
    rename: 'Rename',
    created: 'Created {date}',
    participants: 'Participants ({count})',
    owner: 'Owner',
    add: 'Add people',
    addSelected: 'Add ({count})',
    added: 'Participants added',
    remove: 'Remove {name} from the conversation',
  },
  new: {
    open: 'New conversation',
    title: 'New conversation',
    description: 'Pick a person, create a group or send an announcement to the team.',
    tabDirect: 'Person',
    tabGroup: 'Group',
    tabBroadcast: 'Announcement',
    searchPeople: 'Search people…',
    people: 'People',
    selected: 'Selected people',
    removePerson: 'Remove {name}',
    noPeople: 'No people found',
    error: 'Could not load people.',
    groupTitle: 'Group name (optional)',
    groupTitlePlaceholder: 'e.g. Sales reps — south region',
    broadcastTitle: 'Announcement subject',
    broadcastTitlePlaceholder: 'e.g. New price list from 1 November',
    firstMessage: 'First message (optional)',
    firstMessagePlaceholder: 'Say what this is about right away…',
    broadcastHint: 'Everyone in the announcement can read it, but only its authors can post. Recipients can react with emoji.',
    selectSalesReps: 'Select all sales reps ({count})',
    unselectSalesReps: 'Deselect all sales reps',
    createGroup: 'Create group',
    sendBroadcast: 'Send announcement',
  },
  subject: {
    open: {
      CUSTOMER: 'Chat about customer',
      LEAD: 'Chat about lead',
      APPROVAL_REQUEST: 'Chat about request',
    },
    type: {
      CUSTOMER: 'Customer',
      LEAD: 'Lead',
      APPROVAL_REQUEST: 'Request',
    },
    goTo: 'Go to: {label}',
    notFound: 'You cannot chat about this record — it is outside your data scope.',
  },
  toast: {
    open: 'Open',
  },
};
